import { render, staticRenderFns } from "./McaOmr.vue?vue&type=template&id=c723522a&scoped=true"
import script from "./McaOmr.vue?vue&type=script&lang=ts"
export * from "./McaOmr.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c723522a",
  null
  
)

export default component.exports